import { useCallback, useEffect } from 'react';

import { authDBService } from '~/services';
import { useAuthStore, useLoadingStore } from '~/store';

const LOADING_STATE = 'loading';

/** 사용자의 인증 여부 상태를 관리하기 위한 커스텀 훅 */
const useAuthState = () => {
  const { setIsLoading } = useLoadingStore();
  const { isAuthenticated, setIsAuthenticated } = useAuthStore();

  useEffect(() => {
    setIsLoading(isAuthenticated === LOADING_STATE);
  }, [isAuthenticated, setIsLoading]);

  const updateIsAuthenticated = useCallback(async () => {
    const loginInfo = await authDBService.getLoginInfo();

    setIsAuthenticated(Boolean(loginInfo?.access_token));
  }, [setIsAuthenticated]);

  useEffect(() => {
    updateIsAuthenticated();
  }, [updateIsAuthenticated]);

  return {
    isAuthenticated,
    updateIsAuthenticated,
  };
};

export default useAuthState;
